import {
  CurrencyApprovalProvider,
  isExtraWalletSupported,
  isNFTSale,
  SaleStatus,
  UserExternalWalletsProvider,
  useUser,
  useUserSaleTier,
} from '@trustpad/launchpad';

import axios from 'axios';
import { DBUser } from 'lib/types';

import { usePool } from '~features/pools';
import { UserFinishedSaleStatus } from '~features/pools/components/BuyFromWrapper/UserFinishedSaleStatus';
import { BuyNftForm } from '~features/pools/components/BuyNftForm';
import { BuyTokensForm } from '~features/pools/components/BuyTokensForm/BuyTokensForm';

import { Blocker } from './Blocker';
import { SaleStatusMessage } from './SaleStatusMessage';
import { UserSaleStatus } from './UserSaleStatus';

export const getExternalWallets = (account: string) =>
  axios
    .get<{ user: DBUser }>(`/api/user?account=${account}`)
    .then(({ data }) => data.user.wallets || {});

export function BuyFormWrapper() {
  const { account } = useUser();
  const { pool, isSoldOut } = usePool();
  const { sale, token } = pool;

  const {
    tierState: { tier },
    isWhitelisted,
  } = useUserSaleTier();

  const showAccountInfo =
    account &&
    sale.address &&
    (isWhitelisted ||
      [
        SaleStatus.open,
        SaleStatus.init,
        SaleStatus.finished,
        SaleStatus.register,
      ].includes(sale.status as SaleStatus));

  return (
    <UserExternalWalletsProvider
      fetch={isExtraWalletSupported(token.chain)}
      getWallets={getExternalWallets}>
      <CurrencyApprovalProvider>
        <div className="space-y-3 relative">
          {showAccountInfo &&
            (sale.status === SaleStatus.finished ? (
              <UserFinishedSaleStatus
                stakingTier={tier}
                whitelisted={isWhitelisted}
              />
            ) : (
              <UserSaleStatus stakingTier={tier} whitelisted={isWhitelisted} />
            ))}

          <div className="bg-gray-500 bg-opacity-10 p-3 rounded-2xl relative">
            <Blocker
              pool={pool}
              account={account}
              isWhitelisted={isWhitelisted}
              stakingTier={tier}
              message={
                <SaleStatusMessage
                  isSoldOut={isSoldOut}
                  hadRegistration={!!sale.registerDate}
                  kyc={pool.kyc}
                  status={sale.status}
                />
              }>
              {isNFTSale(sale) ? <BuyNftForm /> : <BuyTokensForm />}
            </Blocker>
          </div>
          <div className="absolute right-0">
            <div className="text-right -mt-2 text-sm">
              <a
                href="https://docs.trustpad.io/trustpad/how-to-participate-in-an-ido#5c07"
                target="_blank"
                rel="noreferrer"
                className="text-gray-500 border-gray-500 border-b border-dashed no-underline hover:border-0 hover:text-gray-500">
                How to participate
              </a>
            </div>
          </div>
        </div>
      </CurrencyApprovalProvider>
    </UserExternalWalletsProvider>
  );
}
